import { useIntl } from 'react-intl';

import { useScenes } from '@/hooks/app/useScenes';
import speakerOffIcon from 'icons/speaker-off.svg';
import speakerOnIcon from 'icons/speaker-on.svg';

import messages from './messages';
import {
	InputContainer,
	Label,
	ProgressBar,
	ProgressBarWrapper,
	RangeBar,
	SpeakerIcon,
	UnfinishedProgressBar,
	Wrapper,
} from './styles';

const SceneVolumeControl = () => {
	const { formatMessage } = useIntl();
	const { sceneVolume, setSceneVolume } = useScenes();

	return (
		<Wrapper>
			<Label htmlFor="volume">{formatMessage(messages.sceneVolume)}</Label>
			<InputContainer>
				<SpeakerIcon
					Icon={speakerOffIcon}
					onPress={() => setSceneVolume(0.0001)}
					aria-label="mute"
					tabIndex={sceneVolume <= 0.0001 ? -1 : 0}
				/>
				<ProgressBarWrapper>
					<UnfinishedProgressBar>
						<ProgressBar percentProgress={sceneVolume * 100} />
					</UnfinishedProgressBar>
					<RangeBar
						id="volume"
						onChange={e => setSceneVolume(Number(e.target.value))}
						max={1}
						min={0}
						step={0.01}
						type="range"
						value={sceneVolume}
					/>
				</ProgressBarWrapper>
				<SpeakerIcon
					Icon={speakerOnIcon}
					onPress={() => setSceneVolume(1)}
					aria-label="max volume"
					tabIndex={sceneVolume >= 1 ? -1 : 0}
				/>
			</InputContainer>
		</Wrapper>
	);
};

export default SceneVolumeControl;
